import { Address } from '~src/model';

export const ADDRESS_BASE_KEYS: (keyof Omit<Address, 'id'>)[] = [
  'city',
  'street',
  'postalCode',
  'houseNumber',
  'floor',
  'door',
];
